import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { ValidezNacionalRow } from "./ValidezNacionalRow";
import { ValidacionNacionalDetailModal } from "../ValidacionNacionalDetailModal/ValidacionNacionalDetailModal";

interface Props {
  elementos: ValidezNacionalI[];
  renderActions?: (
    elemento: ValidezNacionalI,
    onClickShowDetail: (elemento: ValidezNacionalI) => void,
  ) => ReactNode;
}

export const ValidezNacionalTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  const [selectedElement, setSelectedElement] =
    useState<ValidezNacionalI | null>(null);
  const [showModal, setShowModal] = useState(false);

  const onShowDetailModal = (elemento: ValidezNacionalI) => {
    setSelectedElement(elemento);
    setShowModal(true);
  };

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };
  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Aprobacion</th>
            <th>Caducidad</th>
            <th>Plan</th>
            <th>Normativa</th>
            <th>Estado</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "75px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <ValidezNacionalRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Validaciones Nacionales para visualizar.</b> Para
                  poder visualizar Validaciones Nacionales debes <br />{" "}
                  seleccionar el botón agregar «Nueva Validez Nacional».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <ValidacionNacionalDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      ></ValidacionNacionalDetailModal>
    </>
  );
};
